export default "__VITE_ASSET__BcC2MWH0__"